import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Dropdown = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M9.19 14.25A1.43 1.43 0 019 12.79a1.3 1.3 0 011.2-.79h11.39a1.3 1.3 0 011.18.79 1.43 1.43 0 01-.18 1.46L16.9 21.5a1.26 1.26 0 01-2 0zM29 30H3a1 1 0 01-1-1V3a1 1 0 011-1h26a1 1 0 011 1v26a1 1 0 01-1 1zM4 28h24V4H4z" })), '0 0 32 32', 'Dropdown');
//# sourceMappingURL=Dropdown.js.map